import { FC } from "react";
import { useParams } from "react-router";
import { IonContent, IonPage } from "@ionic/react";
import { usePictures } from "../Pictures/usePictures";
import PictureCard from "../Pictures/PictureCard";
import { IPicture } from "../../models";
import Seo from "../../common/Seo";

const Picture: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { catalogPictures } = usePictures();
  const pic: IPicture = catalogPictures.filter((p) => p.code === id)[0];

  return (
    <IonPage id="picture">
      {pic && (
        <Seo
          title={pic.title}
          description={`${pic.title} — set za bojenje po brojevima, dimenzije ${pic.sizeX}x${pic.sizeY} cm. Naručite na Bojenje po brojevima.`}
          path={`/slika/${pic.code}`}
          image={`/assets/pics/${pic.code}.jpg`}
        />
      )}
      <IonContent>
        <PictureCard pic={pic} isDetail />
      </IonContent>
    </IonPage>
  );
};

export default Picture;
